import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import GlobalContext from "../../framework/GlobalContext";
import classes from "./RetailerReports.module.css";
import Reports from "../../common/reports/Reports";
import RetailerReportsSummary from "./RetailerReportsSummary";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import { CONFIGURATION_TAB } from "../../framework/tab/tabUtilsConstants";

const RetailerReports = () => {
  const defaultFilter = useMemo(() => {
    return {
      // filters: [createFilterParam("deleted", false, BOOL, EQ)],
      limit: 100,
      // orderBy: [{ fieldName: "userId" }],
      export: false,
    };
  }, []);
  const { currentComponent, setAddNewTab } = useContext(GlobalContext);
  const reportRef = useRef();
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);

  const editRef = useRef();

  const refreshData = useCallback(() => {
    reportRef.current.applyFilters(defaultFilter);
  }, [defaultFilter]);

  const configHandler = useCallback(
    (branch = true) => {
      setAddNewTab({
        component: CONFIGURATION_TAB,
        props: {
          retailerId: branch
            ? reportRef.current.getCurrentRowData()?._id
            : null,
        },
      });
    },
    [setAddNewTab]
  );

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      const currentRow = reportRef.current.getCurrentRowData();
      if (ctrlKey && key === "i") {
        if (currentRow) editRef.current.click();
        return;
      }
      if (altKey && key === "r") {
        return refreshData();
      }
      if (altKey && key === "c") {
        return configHandler();
      }
      if (altKey && key === "e") {
        return quickExportHandler();
      }
    },
    [configHandler, refreshData]
  );
  const quickExportHandler = () => {
    reportRef?.current?.quickExport({ fileName: "UserReports" });
  };
  useEffect(() => {
    const allRowCTAs = [
      <Button
        startIcon={<Shortcut keys={["Ctrl", "I"]} />}
        label="Edit Congfiuration"
        onClick={configHandler}
        ref={editRef}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [configHandler]);
  useEffect(() => {
    if (currentComponent === "grid_reports") {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener]);
  useEffect(() => {
    refreshData();
  }, [refreshData]);
  return (
    <div className={classes["user-report-container"]}>
      <Reports
        identifier="branch"
        rowLevelCTAs={rowLevelCTAs}
        reportRef={reportRef}
        showFilterCTA={false}
      />
      <RetailerReportsSummary
        refreshData={refreshData}
        quickExport={quickExportHandler}
        defaultConfig={() => configHandler(false)}
      />
    </div>
  );
};

export default RetailerReports;
